import api, { adminApiPrefix, apiPrefix } from './Api';
import {
  ProductPopularity,
  productPopularityFromResponse,
} from '../interfaces/PopularProduct/ProductPopularity';
import {
  ProductPopularityEntry,
  productPopularityEntryToUpdateRequest,
} from '../interfaces/PopularProduct/ProductPopularityEntry';
import {
  DailyPopularProductMedia,
  dailyPopularProductMediaFromResponse,
} from '../interfaces/PopularProduct/DailyPopularProductMedia';

const popularProductAdminApiPrefix = `${adminApiPrefix}/popular-product`;

export const getDailyPopularProductMedia =
  async (): Promise<DailyPopularProductMedia> => {
    const response = await api.get(`${apiPrefix}/daily-products`);

    return dailyPopularProductMediaFromResponse(response.data?.data?.detail);
  };

export const getProductPopularities = async (): Promise<
  ProductPopularity[]
> => {
  const response = await api.get(popularProductAdminApiPrefix);

  return (response.data?.data ?? []).map((p: any) =>
    productPopularityFromResponse(p),
  );
};

export const updateHighlightedProductOrders = async (
  entries: ProductPopularityEntry[],
): Promise<void> =>
  api.put(`${popularProductAdminApiPrefix}/highlighted`, {
    updates: entries.map((entry) =>
      productPopularityEntryToUpdateRequest(entry),
    ),
  });

export const updateDailyPopularProductOrders = async (
  entries: ProductPopularityEntry[],
): Promise<void> =>
  api.put(`${popularProductAdminApiPrefix}/daily`, {
    updates: entries.map((entry) =>
      productPopularityEntryToUpdateRequest(entry),
    ),
  });

export const updateDailyProductMedia = async (
  media: DailyPopularProductMedia,
): Promise<void> => {
  const bodyFormData = new FormData();

  if (media.coverImage) {
    bodyFormData.append('cover-image', media.coverImage);
  }

  if (media.eraseCoverImage) {
    bodyFormData.append('erase-cover-image', '1');
  }

  if (media.videoURL) {
    bodyFormData.append('video-url', media.videoURL);
  }

  return api.put(`${popularProductAdminApiPrefix}/daily/media`, bodyFormData);
};

export const updateProductPopularities = async (
  entries: ProductPopularityEntry[],
): Promise<void> =>
  api.put(`${popularProductAdminApiPrefix}/popularity`, {
    updates: entries.map((entry) =>
      productPopularityEntryToUpdateRequest(entry),
    ),
  });
